export const onSetPresence = (presence) => ({
  type: 'SET_PRESENCE',
  presence
})
